<template>
  <div>
    <div v-if="error != null">
      <div class="row">
        <div class="col">
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col">
          <p>Once an author has been saved you may add additional institutes.</p>
        </div>
      </div>
    </div>
    <div v-if="importMode === null">
      <div class="row" v-if="importMode === null">
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              Submitter
            </div>
            <div class="card-body">
              <p class="card-text">We import you as an author.</p>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="importSubmitter()">Select</button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              Search
            </div>
            <div class="card-body">
              <p class="card-text">Search for new author in the UEG database or enter manually</p>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="importMode = 'search'">Select</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Cancel</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'search' && selected === null">
      <div class="row">
        <div class="col">
          <div class="row form-group">
            <div class="col">
              <label class="col-form-label font-weight-bold p-0">
                <span>Name</span> <span class="mandatory">*</span>
              </label>
              <small class="form-text text-muted">
                Please enter the name of the author you are looking for
              </small>
              <input type="text" name="name" required="required" autocomplete="on" class="form-control"
                     v-model="searchfields.name" v-on:keydown.enter="search()">
            </div>
          </div>
          <div class="row form-group mt-3 mb-3">
            <div class="col">
              <div class="">
                <label class="col-form-label font-weight-bold p-0">
                  <span>E-mail</span>
                </label>
                <input type="text" name="email" autocomplete="on" class="form-control" v-model="searchfields.email"
                       v-on:keydown.enter="search()">
              </div>
            </div>
          </div>
          <div class="row form-group mt-3 mb-3">
            <div class="col">
              <div class="">
                <label class="col-form-label font-weight-bold p-0">
                  <span>Town</span>
                </label>
                <input type="text" name="city" autocomplete="on" class="form-control" v-model="searchfields.city"
                       v-on:keydown.enter="search()">
              </div>
            </div>
          </div>
          <div class="row form-group mt-3 mb-3">
            <div class="col">
              <div class="">
                <label class="col-form-label font-weight-bold p-0">
                  <span>Country</span>
                </label>
                <treeselect
                    class="w-auto"
                    value-consists-of="BRANCH_PRIORITY"
                    v-model="searchfields.country" :options="this.countryData()"></treeselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col d-flex">
              <Button class="btn btn-sm btn-success ml-auto" :disabled="processing === true" v-on:click="search()">
                Search
              </Button>
            </div>
          </div>
        </div>
        <div class="col border-left" v-if="results != null && !processing">
          <div>
            <div class="font-weight-bold p-0">Select result</div>
            <small class="text-muted">Please select an author from the list or create it manually. </small>
          </div>
          <Button class="btn btn-sm btn-primary" v-on:click="manually()">Enter manually</Button>
          <div class="list-group mt-3">
            <button type="button" class="list-group-item list-group-item-action" v-for="result in results"
                    v-bind:key="result.id" v-on:click="selectNewAuthor(result)">
              <div>
                <span v-if="result.last_name">{{ result.last_name }},&nbsp;</span>
                <span v-if="result.first_name">{{ result.first_name }}</span>
              </div>
              <div class="smaller">
                <div v-if="result.institute_name_c && result.institute_name_c.trim().length > 1">Company:
                  {{ result.institute_name_c }}
                </div>
                <div v-if="result.department && result.department.trim().length > 1">
                  Department: {{ result.department }}
                </div>
                <div v-if="result.primary_address_city">Town: {{ result.primary_address_city }}</div>
              </div>
            </button>
          </div>
        </div>
        <div class="col border-left" v-else-if="processing === true">
          <loader></loader>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Cancel</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'submitter' && processing === true">
      <loader></loader>
    </div>
    <div v-else-if="importAuthor">
      <AuthorForm @authorCreated="authorCreated"></AuthorForm>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">Cancel</button>
          <Button class="btn btn-sm btn-primary ml-3" v-on:click="manually()">Enter manually</Button>
        </div>
      </div>
    </div>
    <div v-else-if="importInstitute">
      <Instituteform @instituteCreated="instituteCreated"></Instituteform>
    </div>
  </div>
</template>

<script>
import entitegenerator from "entite-generator";
import {mapActions, mapGetters, mapState, mapMutations} from "vuex";
import AuthorForm from "../author/AuthorForm";
import Instituteform from "../author/InstituteForm";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Instituteform,
    AuthorForm,
    entitegenerator,
    Treeselect
  },
  name: "AuthorSearch",
  data() {
    return {
      importMode: 'search', //null, search, submitter
      searchfields: {},
      results: null,
      error: null,
      selected: null,
      importAuthor: false,
      importInstitute: false,
      processing: false,
    };
  },
  computed: {
    ...mapState(["mode", "user", "abstract"]),
    ...mapState('uegcrm', ["selectedAuthor", "selectedInstitute"])
  },
  mounted() {
    this.importMode = null;
  },
  methods: {
    ...mapActions('uegcrm', ['GET_AUTHORS', 'GET_AUTHOR']),
    ...mapMutations('uegcrm', ['SET_SELECTEDAUTHOR', 'SET_SELECTEDINSTITUTE']),
    async importSubmitter() {
      this.processing = true;
      this.importMode = 'submitter';
      await this.GET_AUTHOR({id: this.user.extra.ueg2.crmID}).then((result) => {
        this.selectNewAuthor(result.data);
      }).catch((error) => {
      });
      this.processing = false;
    },
    async search() {
      this.error = null;
      if (this.processing === true) {
        return;
      }
      if (!this.searchfields.name || this.searchfields.name.length < 2) {
        this.error = 'The name must be completed and at least two characters long.';
        return;
      }
      let searchQuery = '';
      let searchQueryReverse = '';
      let searchTerms = this.searchfields.name.trim().split(' ');
      let searchTermsAmount = searchTerms.length;
      switch (searchTermsAmount) {
        case 1:
          searchQuery = 'firstname=' + searchTerms[0];
          searchQueryReverse = 'lastname=' + searchTerms[0];
          break;
        case 2:
          searchQuery = 'firstname=' + searchTerms[0] + '&lastname=' + searchTerms[1];
          searchQueryReverse = 'lastname=' + searchTerms[0] + '&firstname=' + searchTerms[1];
          break;
        default:
          let last = searchTerms.pop();
          searchQuery = 'firstname=' + searchTerms[0] + '&lastname=' + last;
          searchQueryReverse = 'lastname=' + searchTerms[0] + '&firstname=' + last;
          break;
      }
      if (this.searchfields.email && this.searchfields.email.length > 2) {
        searchQuery += '&email=' + this.searchfields.email;
        searchQueryReverse += '&email=' + this.searchfields.email;
      }
      if (this.searchfields.city && this.searchfields.city.length > 2) {
        searchQuery += '&town=' + this.searchfields.city;
        searchQueryReverse += '&town=' + this.searchfields.city;
      }
      if (this.searchfields.country) {
        searchQuery += '&country=' + this.searchfields.country;
        searchQueryReverse += '&country=' + this.searchfields.country;
      }
      this.processing = true;
      this.results = null;
      let mergeResults = [];
      await this.GET_AUTHORS({query: searchQuery}).then((result) => {
        mergeResults = result.data;
      }).catch((error) => {
      });
      console.log(mergeResults)
      await this.GET_AUTHORS({query: searchQueryReverse}).then((result) => {
        if (mergeResults.length > 0) {
          mergeResults = mergeResults.concat(result.data);
        } else {
          mergeResults = result.data;
        }
      }).catch((error) => {
      });
      console.log(mergeResults)
      this.results = [];
      if (mergeResults.length > 0) {
        mergeResults.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.results = mergeResults;
      }
      this.processing = false;
    },
    selectNewAuthor(data) {
      this.$set(this.mode, 'import', true);
      let email = data.email.find(mail => mail.primary_address === true).email_address;
      let mytype = 0;
      if(this.abstract.type_id) {
        mytype = this.abstract.type_id;
      }
      let mappedAuthor = {
        'external_id': data.open_id_c,
        'firstname': data.first_name.trim(),
        'lastname': data.last_name.trim(),
        'email': email.trim(),
        'type_id': mytype
      };
      if (data.salutation) {
        switch (data.salutation) {
          case 'Mr.':
            mappedAuthor.gender_id = 1;
            break;
          case 'Ms.':
            mappedAuthor.gender_id = 2;
            break;
        }
      }
      if (!mappedAuthor.gender && data.gender_c) {
        switch (data.gender_c) {
          case 'Male':
            mappedAuthor.gender_id = 1;
            break;
          case 'Female':
            mappedAuthor.gender_id = 2;
            break;
        }
        if (data.date_of_birth) {
          mappedAuthor.additional_content__dateofbirth = data.date_of_birth;
        }
      }
      if (data.academic_title_c) {
        mappedAuthor.title = data.academic_title_c.trim();
      }
      this.SET_SELECTEDAUTHOR({'selectedAuthor': mappedAuthor});
      this.selectNewInsitute(data);
      this.selected = data;
      this.importAuthor = true;
      this.importInstitute = false;
    },
    selectNewInsitute(data) {
      this.$set(this.mode, 'import', true);
      let mappedInstitute = {};
      if (data.institute_name_c) {
        mappedInstitute.name = data.institute_name_c.trim();
      }
      if (data.department) {
        mappedInstitute.department = data.department.trim();
      }
      if (data.primary_address_street) {
        mappedInstitute.street = data.primary_address_street.trim();
      }
      if (data.primary_address_city) {
        mappedInstitute.city = data.primary_address_city.trim();
      }
      if (data.primary_address_postalcode) {
        mappedInstitute.zip_code = data.primary_address_postalcode.trim();
      }
      if (data.primary_address_state) {
        mappedInstitute.state = data.primary_address_state.trim();
      }
      if (data.primary_address_country_drop_c) {
        mappedInstitute.country_code = data.primary_address_country_drop_c;
      }
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': mappedInstitute});
    },
    authorCreated(author_id) {
      console.log('authorCreated')
      this.selectedInstitute.author_id = author_id;
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': this.selectedInstitute});
      this.$store.dispatch('GET_ONE_AUTHOR', author_id);
      this.importAuthor = false;
      this.importInstitute = true;
    },
    instituteCreated() {
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id)
      this.cancel();
    },
    cancel() {
      this.$set(this.mode, 'import', false);
      $('#authorImportModal').modal('hide');
    },
    manually() {
      this.cancel();
      this.$emit('enterManually');
    }
  }
}
</script>

<style scoped>

</style>
